module.exports = __webpack_public_path__ + "img/by.5630d402.svg";